module.exports = __webpack_public_path__ + "img/undraw_add_files_re_v09g.dd3b840c.svg";